import React from 'react';
import Alert from '@amzn/meridian/alert';
import { isEmpty } from "src/utils/object-utils";
import { AlertLevel, AlertLevels } from "src/models/alert-model";
import {
    DEFAULT_ALERT_LEVEL_TO_TIMEOUT_MAPPING
} from "src/components/common/status-alert/constants/alert-level-to-timeout-map";
import { awsRum } from 'src/serviceClients/aws-rum/awsRum-Service';
import { ClientSideMetricsConstants } from 'src/constants/client-side-metrics-constants';

interface StatusAlertStateProps {
    alertLevel: AlertLevel;
    alertTitleString: string;
    alertMessageString: string;
    alertTimeoutInMs?: number;
    alertSize?: string;
    alertStatus?: number;
    UIAction?: string;
    warehouse?: string;
    associate?: string;
    mode?: string;
}

interface StatusAlertDispatchProps {
    resetUiAlertState: () => void;
}

type Props = StatusAlertStateProps & StatusAlertDispatchProps;

class StatusAlert extends React.Component<Props> {

    private timeOutVariable: any;
    private handleResetAlert = (delayInMs: number): void => {
        if (delayInMs > 0) {
            this.timeOutVariable = setTimeout(() => {
                this.props.resetUiAlertState();
            }, delayInMs);
        }
    }

    private getSize = (): any => {
        return isEmpty(this.props.alertSize) ? 'large' : this.props.alertSize;
    }

    public render() {
        // reset previous timeout
        clearTimeout(this.timeOutVariable);

        // Record RUM event for errors
        if (this.props.alertLevel === AlertLevels.ERROR && this.props.alertStatus) {
            const eventName = this.props.alertStatus === 400 
                ? ClientSideMetricsConstants.FATAL_RIV_USER_EXCEPTION
                : ClientSideMetricsConstants.FATAL_RIV;
                
            const eventData = {
                UIAction: this.props.UIAction,
                ErrorStatus: this.props.alertStatus,
                ErrorMessage: this.props.alertMessageString,
                Warehouse: this.props.warehouse,
                Associate: this.props.associate,
                Mode: this.props.mode
            };
                
            // Also record combined FATAL event for both 400 and 500
            awsRum.recordEvent(ClientSideMetricsConstants.FATAL, eventData);
            
            // Record specific event
            awsRum.recordEvent(eventName, eventData);
        }

        // set new timeout
        if (this.props.alertTimeoutInMs && this.props.alertTimeoutInMs >= 0) {
            this.handleResetAlert(this.props.alertTimeoutInMs)
        } else if (this.props.alertLevel !== AlertLevels.UNDEFINED) {
            this.handleResetAlert(DEFAULT_ALERT_LEVEL_TO_TIMEOUT_MAPPING[this.props.alertLevel]);
        }

        return (
            <div data-testid="status-alert">
                { this.props.alertLevel !== AlertLevels.UNDEFINED && (
                    <Alert
                        type={this.props.alertLevel}
                        title={this.props.alertTitleString}
                        size={this.getSize()}
                    >
                        {this.props.alertMessageString}
                    </Alert>
                )}
            </div>

        );
    }
}

export default StatusAlert;